"use strict";

document.addEventListener("DOMContentLoaded", () => {
    stickyMenu();
});

const stickyMenu = () => {
    const navLinks = document.querySelectorAll(".sticky-menu a");
    const sections = [];

    navLinks.forEach(link => {
        const anchor = document.querySelector(link.getAttribute("href"));
        if (!anchor) {
            // console.warn("Brak sekcji dla linku:", link.getAttribute("href"));
            return;
        }
        const section = anchor.closest("section");
        if (section) {
            sections.push({ link, section });
        }
    });

    const activateLink = () => {
        const scrollPos = window.scrollY;
        sections.forEach(({ link, section }) => {
            const top = section.offsetTop - 160;
            const bottom = top + section.offsetHeight;
            if (scrollPos >= top && scrollPos < bottom) {
                sections.forEach(({ link }) => link.classList.remove("active"));
                link.classList.add("active");
            }
        });
    };

    window.addEventListener("scroll", activateLink);
    activateLink();
};
